import { render, staticRenderFns } from "./personholiday.vue?vue&type=template&id=627312fb&scoped=true&"
import script from "./personholiday.vue?vue&type=script&lang=js&"
export * from "./personholiday.vue?vue&type=script&lang=js&"
import style0 from "./personholiday.vue?vue&type=style&index=0&id=627312fb&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627312fb",
  null
  
)

export default component.exports